import { PARENT_ROUTE as ADMIN_PARENT_ROUTE } from '../admin';

const PARENT_ROUTE = '/micro-learning';
const ADMIN_MICRO_LEARNING_PARENT_ROUTE = `${ADMIN_PARENT_ROUTE}${PARENT_ROUTE}`;

const adminMicroLearningRoutes = {
  MicroLearningBuilder: (courseId: string) =>
    `${ADMIN_MICRO_LEARNING_PARENT_ROUTE}/${courseId}/build`,
  MicroLearningPreview: (courseId: string) =>
    `${ADMIN_MICRO_LEARNING_PARENT_ROUTE}/${courseId}/preview`,
  MicroLearningDevicesPreview: (courseId: string) =>
    `${ADMIN_MICRO_LEARNING_PARENT_ROUTE}/${courseId}/preview-devices`,
  MicroLearningCreatorSelection: () => `${ADMIN_MICRO_LEARNING_PARENT_ROUTE}/choose`,
  MicroLearningCreator: (query?: string) =>
    `${ADMIN_MICRO_LEARNING_PARENT_ROUTE}/create${query ? `?${query}` : ''}`,
  MicroLearningCreatorSelector: () => `${ADMIN_MICRO_LEARNING_PARENT_ROUTE}/choose`,
  MicroLearningViewerAdmin: (courseId: string) =>
    `${ADMIN_MICRO_LEARNING_PARENT_ROUTE}/${courseId}/view`,
  MicroLearningLearnersReport: (courseId: string) =>
    `${ADMIN_MICRO_LEARNING_PARENT_ROUTE}/${courseId}/reports/learners`,
  MicroLearningAssessmentsReport: (courseId: string) =>
    `${ADMIN_MICRO_LEARNING_PARENT_ROUTE}/${courseId}/reports/assessments`,
  MicroLearningLessonsReport: (courseId: string) =>
    `${ADMIN_MICRO_LEARNING_PARENT_ROUTE}/${courseId}/reports/lessons`,
  MicroLearningFeedbackReport: (courseId: string) =>
    `${ADMIN_MICRO_LEARNING_PARENT_ROUTE}/${courseId}/reports/feedback`,
  AdminMicroLearningDetails: (courseId: string) =>
    `${ADMIN_MICRO_LEARNING_PARENT_ROUTE}/${courseId}/details`,
};

const learnerMicroLearningRoutes = {
  MicroLearningViewer: (courseId: string) => `${PARENT_ROUTE}/${courseId}/view`,
  MicroLearningDetails: (courseId: string) => `${PARENT_ROUTE}/${courseId}/details`,
  MicroLearningReview: (courseId: string) => `${PARENT_ROUTE}/${courseId}/view/review`,
  MicroLearningLessonViewer: (courseId: string, lessonPageId: string) =>
    `${PARENT_ROUTE}/${courseId}/view?lessonPageId=${lessonPageId}`,
};

export const microLearningDetailRoute = (courseId: string) => ({
  admin: adminMicroLearningRoutes.AdminMicroLearningDetails(courseId),
  learner: learnerMicroLearningRoutes.MicroLearningDetails(courseId),
});

export const microLearningViewerRoute = (courseId: string) => ({
  admin: adminMicroLearningRoutes.MicroLearningDevicesPreview(courseId),
  learner: learnerMicroLearningRoutes.MicroLearningViewer(courseId),
});

export const microLearningRoutes = {
  ...adminMicroLearningRoutes,
  ...learnerMicroLearningRoutes,
};

export const ADMIN_MICRO_LEARNING_ROUTE_KEYS = {
  MicroLearningBuilder: 'MicroLearningBuilder',
  MicroLearningCreator: 'MicroLearningCreator',
  MicroLearningReport: 'MicroLearningReport',
  MicroLearningPreview: 'MicroLearningPreview',
  MicroLearningReview: 'MicroLearningReview',
  MicroLearningLearnersReport: 'MicroLearningLearnersReport',
  MicroLearningAssessmentsReport: 'MicroLearningAssessmentsReport',
  AdminMicroLearningDetails: 'AdminMicroLearningDetails',
};

export const LEARNER_MICRO_LEARNING_ROUTE_KEYS = {
  MicroLearningViewer: 'MicroLearningViewer',
  MicroLearningDetails: 'MicroLearningDetails',
};

export const MICRO_LEARNING_ROUTE_KEYS = {
  ...ADMIN_MICRO_LEARNING_ROUTE_KEYS,
  ...LEARNER_MICRO_LEARNING_ROUTE_KEYS,
};

export default microLearningRoutes;
